import { AbsgArrayHelper, DefaultAzureHeaders, EnvironmentConfiguration, LogService } from '@absg/angular-common';
import { ODataAzureQuery, ODataResult } from '@absg/angular-components';
import { BaseService } from '@absg/nim-client-shared';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DiagnosisCode, DiagnosisCodeContract } from '../models/diagnosis-code.model';

@Injectable({ providedIn: 'root' })
export class DiagnosisCodeService extends BaseService {
  endpointUrl: string;
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private environment: EnvironmentConfiguration,
    private azureHeaderFactory: DefaultAzureHeaders,
    loggingService: LogService,
  ) {
    super(loggingService);
    this.setupService();
  }

  setupService(): void {
    const diagnosisCodeEnv = this.environment.apis.diagnosisCode;
    this.endpointUrl = diagnosisCodeEnv.endpointUrl;
    this.headers = this.azureHeaderFactory.createHeaders();
    this.headers = this.headers
      .set(diagnosisCodeEnv.subscriptionKeyHeaderName, diagnosisCodeEnv.subscriptionKey);
  }

  searchDiagnosis(query: string): Observable<ODataResult<DiagnosisCode>> {
    return this.searchDiagnosisWithHttpInfo({ search: query });
  }

  getDiagnosesFromCodes(codes: string[]): Observable<ODataResult<DiagnosisCode>> {
    if (!codes || codes.length === 0) {
      return of(new ODataResult<DiagnosisCode>([]));
    }
    const searchBuilder = new ODataAzureQuery({
      itemsPerPage: 1000,
      pageNumber: 1,
      searchFields: ['ICDCode'],
      selectFields: ['ICDCode', 'ICDLabel'],
      searchTerms: codes,
      isInSearch: true,
      additionalFilters: "ICDCodeType eq 'ICD10'",
    });

    return this.searchDiagnosisWithHttpInfo({ search: searchBuilder.toString() });
  }

  searchDiagnosisWithHttpInfo(extraHttpRequestParams = { search: '' }): Observable<ODataResult<DiagnosisCode>> {
    if (!this.endpointUrl) {
      this.setupService();
    }
    const headers = this.headers;
    const url = this.endpointUrl;
    let params: HttpParams;

    if (extraHttpRequestParams.search) {
      params = new HttpParams({ fromString: extraHttpRequestParams.search });
    }

    return this.http
      .get<ODataResult<DiagnosisCodeContract>>(url, { headers, params })
      .pipe(
        map(response => this.convertDataModel(response)),
        catchError((response: HttpErrorResponse) => this.handleErrorResponse(response)),
      ) as Observable<ODataResult<DiagnosisCode>>;
  }

  convertDataModel(response: ODataResult<DiagnosisCodeContract>): ODataResult<DiagnosisCode> {
    const result = new ODataResult<DiagnosisCode>();
    result.value = [];

    result['odata.count'] = response['@odata.count'];
    result.value = AbsgArrayHelper.map(response.value, diagnosisCode => {
      const localDiagnosisCode =
        {
          code: diagnosisCode.ICDCode,
          name: diagnosisCode.ICDLabel,
          selected: false,
          disabled: false,
        } as DiagnosisCode;
      return localDiagnosisCode;
    });
    return result;
  }
}
